import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import {
  createNewVirtual,
  getVirtuals,
  getVirtual,
  postVirtual,
  patchVirtual,
  putStops,
} from '../common/actions/virtuals';
import { getFilterStr, getMediaForUIName, openPreviewWindow } from '../common/global';
import { getProductById, getProductsByQuery } from '../common/actions/products';
import { getUsers, getUserById } from '../common/actions/users';
import { getSparks } from '../common/actions/sparks';
import { getChallengesBySparkId } from '../common/actions/challenges';
import { getCluesBySparkId } from '../common/actions/clues';
import { uploadMedia } from '../common/actions/medias';

import VirtualList from '../molecules/virtuals/VirtualList';

import styles from './VirtualsPage.module.scss';
import VirtualDetails from '../molecules/virtuals/VirtualDetails';
import Stops from '../molecules/virtuals/Stops';

class VirtualsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { searchText: '' };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const { isRefreshRequired = false } = this.props;

    if (isRefreshRequired === true && prevProps.isRefreshRequired !== isRefreshRequired) {
      this.loadData();
    }
  }

  loadData() {
    const {
      id = '',
      newVirtualId,
      productId = '',
      getVirtualsFunc,
      getVirtualFunc,
      getProductByIdFunc,
      getUsersFunc,
      getSparksFunc,
    } = this.props;

    getVirtualsFunc();

    const virtualId = !isEmpty(id) ? id : newVirtualId;

    if (isEmpty(virtualId)) return;

    getVirtualFunc(virtualId);
    getProductByIdFunc(productId);
    getUsersFunc();
    getSparksFunc();
  }

  onChangeSearchText = (searchText) => {
    const { filter = {}, getVirtualsFunc } = this.props;
    let filterStr = getFilterStr(filter);
    filterStr += '&query=' + searchText;

    getVirtualsFunc(filterStr);

    this.setState({
      searchText,
    });
  };

  onSelectVirtual = (virtual) => {
    const { getVirtualFunc, getProductByIdFunc } = this.props;

    const { id = '', productId = '', userId = '-1' } = virtual;
    getVirtualFunc(id);
    getProductByIdFunc(productId);
    getUserById(userId);
  };

  onCreateVirtual = () => {
    const { createNewVirtualFunc, getProductByIdFunc } = this.props;

    getProductByIdFunc('-1');
    createNewVirtualFunc();
  };

  onSaveVirtual = (virtual) => {
    if (isEmpty(virtual)) return null;
    const { postVirtualFunc, patchVirtualFunc } = this.props;

    if (virtual.id) {
      patchVirtualFunc(virtual);
    } else {
      postVirtualFunc(virtual);
    }
  };

  onSaveStops = (stops) => {
    const { virtual = {} } = this.props;
    const { id } = virtual;

    this.props.putStopsFunc(id, this.getNewStops(stops));
  };

  getNewStops(stops) {
    const newStops = [];
    stops.forEach((stop) => {
      let newStop = {};

      if (stop.spark) newStop.sparkId = stop.spark.id;
      if (stop.clue) newStop.clueId = stop.clue.id;
      if (stop.challenge) newStop.challengeId = stop.challenge.id;
      newStop.action = stop.action;
      newStops.push(newStop);
    });

    return newStops;
  }

  onInputChangeProduct = (query) => {
    const { getProductsByQueryFunc } = this.props;
    getProductsByQueryFunc(query);
  };

  onChangeProductById = (productId) => {
    const { getProductByIdFunc } = this.props;
    getProductByIdFunc(productId);
  };

  onSelectSpark = (spark) => {
    const { id = '' } = spark;
    const { getChallengesBySparkIdFunc, getCluesBySparkIdFunc } = this.props;
    getChallengesBySparkIdFunc(id);
    getCluesBySparkIdFunc(id);
  };

  onInputChangeSpark = (query) => {
    const { getSparksFunc } = this.props;
    const filterStr = `&query=${query}`;

    getSparksFunc(filterStr);
  };

  renderVirtualList() {
    const { virtuals, virtual } = this.props;
    return (
      <div className={styles.left} key="virtualList">
        <VirtualList
          virtuals={virtuals}
          virtual={virtual}
          onSelectVirtualFunc={this.onSelectVirtual}
          onCreateVirtualFunc={this.onCreateVirtual}
          onChangeSearchTextFunc={this.onChangeSearchText}
        />
      </div>
    );
  }

  renderVirtualsDetails() {
    const {
      virtual = {},
      users = {},
      user,
      products,
      product,
      virtualMedia,
      uploadMediaFunc,
    } = this.props;

    if (isEmpty(virtual)) return <div />;

    return (
      <div className={styles.center}>
        <VirtualDetails
          virtual={virtual}
          media={virtualMedia}
          user={user}
          product={product}
          users={users}
          products={products}
          onSaveVirtualFunc={this.onSaveVirtual}
          onInputChangeProductFunc={this.onInputChangeProduct}
          onChangeProductByIdFunc={this.onChangeProductById}
          uploadMediaFunc={uploadMediaFunc}
        />
      </div>
    );
  }

  renderVirtualOthers() {
    const {
      virtual = { id: '-1' },
      sparks = [],
      challenges = [],
      clues = [],
      getChallengesBySparkIdFunc,
      getCluesBySparkIdFunc,
    } = this.props;

    const { stops = [] } = virtual;

    function onClickPreview() {
      openPreviewWindow({ virtualId : virtual.id })
    }

    if (isEmpty(virtual) || virtual.id === '-1') return <div />;
    return (
      <div className={styles.right}>
        <Stops
          stops={stops}
          sparks={sparks}
          challenges={challenges}
          clues={clues}
          onClickPreview={onClickPreview}
          onSaveStopsFunc={this.onSaveStops}
          onSelectSparkFunc={this.onSelectSpark}
          onInputChangeSparkFunc={this.onInputChangeSpark}
          getChallengesBySparkIdFunc={getChallengesBySparkIdFunc}
          getCluesBySparkIdFunc={getCluesBySparkIdFunc}
        />
      </div>
    );
  }

  render() {
    let components = [];
    components.push(this.renderVirtualList());
    components.push(this.renderVirtualsDetails());
    components.push(this.renderVirtualOthers());
    return <div className={styles.root}>{components}</div>;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createNewVirtualFunc: () => dispatch(createNewVirtual()),

    getVirtualsFunc: (filterParams) => dispatch(getVirtuals(filterParams)),
    getVirtualFunc: (id) => dispatch(getVirtual(id)),
    getProductsByQueryFunc: (query) => dispatch(getProductsByQuery(query)),
    getProductByIdFunc: (id) => dispatch(getProductById(id)),
    getUsersFunc: () => dispatch(getUsers()),
    getUserByIdFunc: (id) => dispatch(getUserById(id)),
    getSparksFunc: (filterParams) => dispatch(getSparks(filterParams)),
    getChallengesBySparkIdFunc: (sparkId) => dispatch(getChallengesBySparkId(sparkId)),
    getCluesBySparkIdFunc: (sparkId) => dispatch(getCluesBySparkId(sparkId)),

    patchVirtualFunc: (virtual) => dispatch(patchVirtual(virtual)),
    putStopsFunc: (virtualId, stops) => dispatch(putStops(virtualId, stops)),

    postVirtualFunc: (virtual) => dispatch(postVirtual(virtual)),

    uploadMediaFunc: (mediaFor, mediaType, file) =>
      dispatch(uploadMedia(mediaFor, mediaType, file)),
  };
};

const mapStateToProps = (state) => {
  const stateVirtuals = state.virtuals || {};
  const stateProducts = state.products || {};
  const stateUsers = state.users || {};
  const stateSparks = state.sparks || {};
  const stateChallenges = state.challenges || {};
  const stateClues = state.clues || {};
  const stateMedias = state.medias || {};

  const {
    isRefreshRequired = false,
    virtuals = [],
    virtual = {},
    error = {},
    newVirtualId,
  } = stateVirtuals;

  const { sparks = [] } = stateSparks;
  const { challenges = [] } = stateChallenges;
  const { clues = [] } = stateClues;
  const { media = {} } = stateMedias;
  const { ui = '' } = media;

  let product, products, isValidProductId, users, user;

  const virtualMedia = ui === getMediaForUIName().virtual ? media : {};

  // TODO: Clean Products Reducer
  if (stateProducts) {
    if (stateProducts.error) {
      console.error("'products-action-error:'", stateProducts.error.message);
    }
    if (stateProducts.product) {
      product = stateProducts.product.data;
      if (stateProducts.product.data && stateProducts.product.data.id) {
        isValidProductId = true;
      } else {
        isValidProductId = false;
      }
    }
    if (stateProducts.products) {
      products = stateProducts.products;
    }
  }

  // TODO: Clean Users Reducer
  if (stateUsers) {
    if (stateUsers.error) {
      console.error('users-action-error:', stateUsers.error.message);
    }
    if (stateUsers.users) {
      users = stateUsers.users;
    }
    if (stateUsers.user) {
      user = stateUsers.user.data;
    }
  }

  if (!isEmpty(error)) {
    console.log('virtual-experience-error:', error.message);
  }

  return {
    isRefreshRequired,
    virtuals,
    virtual,
    products,
    product,
    isValidProductId,
    users,
    user,
    sparks,
    challenges,
    clues,
    virtualMedia,
    newVirtualId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VirtualsPage);
